import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-744
import { makeGetRequest } from 'utils/api'
import { wizardAPI } from 'utils/wizardAPI'
import { Input } from './Input'

export default function DefinirObjective() {
  let w_dobjective = localStorage.getItem('w-dobjective')

  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (w_dobjective) {
      setOpen(true)
    }
  }, [])
  return <>{open && <DefinissezObjective setOpen={setOpen} />}</>
}

function DefinissezObjective({ setOpen }) {
  const navigate = useNavigate()
  const { t } = useTranslation('layout') // LAP-744
  let w_dobjective = localStorage.getItem('w-dobjective')
  const { handleSubmit, control, reset } = useForm({})

  useEffect(() => {}, [])

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    let payload = {}
    Object.keys(data).forEach((v) => {
      if (data[v]) {
        payload = { ...payload, [v]: data[v] }
      }
    })
    
    try {
      await wizardAPI.createObjectives(payload)
      localStorage.setItem('wdo_done', true)
      navigate('/')
    } catch (error) {
      console.error('Error creating objectives:', error)
      alert('Erreur lors de la création des objectifs. Veuillez réessayer.')
    }
  }

  const fetchQuestionanswer = async () => {
    const { data, status } = await makeGetRequest('url', {}, true)
    if (status === 200) {
      // setQuestionanswer(data)
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="lg" open={true} className="no-drag">
        <DialogTitle sx={{ color: '#383838 !important' }}>
          {t('definirObjective.title', 'Définissez vos 25 grands objectifs de vie')}
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Box textAlign={'center'} fontWeight={700}>
              {t('definirObjective.heading', 'Imaginez votre futur. Qu’aspirez-vous à accomplir dans les années à venir ?')}
            </Box>
            <Box mt={3}>
              {t(
                'definirObjective.body',
                "Saisissez jusqu'à 25 grands objectifs de vie. Ils peuvent être personnels, professionnels, ou liés à tout autre domaine de votre existence. Chaque objectif fera partie de votre vision à long terme, avec tout le temps nécessaire pour l’atteindre."
              )}
            </Box>
            <Box display={'flex'} mt={2}>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname1"
                  label="Bonne santé physique"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname2"
                  label="Avoir un logement"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname3"
                  label="Avoir assez d'argent"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname4"
                  label="Conserver la stabilité"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname5"
                  label="Éviter les risques majeurs"
                />
              </Box>
            </Box>
            <Box display={'flex'}>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname6"
                  label="Réussir professionnellement"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname7"
                  label="Fonder une famille"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname8"
                  label="Explorer le monde"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname9"
                  label="Transmettre"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname10"
                  label="Laisser un héritage durable"
                />
              </Box>
            </Box>
            <Box display={'flex'}>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname11"
                  label="Apprendre en continu"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname12"
                  label="Cultiver mes relations"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname13"
                  label="Vivre des aventures"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname14"
                  label="Contribuer à une cause"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname15"
                  label="Atteindre l'équilibre vie pro/perso"
                />
              </Box>
            </Box>
            <Box display={'flex'}>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname16"
                  label="Améliorer mon bien-être mental"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname17"
                  label="Investir et faire fructifier"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname18"
                  label="Préparer ma retraite"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname19"
                  label="Devenir entrepreneur"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname20"
                  label="Voyager régulièrement"
                />
              </Box>
            </Box>
            <Box display={'flex'}>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname21"
                  label="Pratiquer un sport"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname22"
                  label="Développer ma créativité"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname23"
                  label="Prendre soin de mes proches"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname24"
                  label="Adopter un mode de vie écoresponsable"
                />
              </Box>
              <Box>
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    // required: true,
                    size: 'small',
                    type: 'text',
                  }}
                  //   rules={{ required: true }}
                  name="objname25"
                  label="Réaliser un projet personnel"
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button type="submit">{t('common.validate', 'Valider')}</Button>
            <Button
              onClick={() => {
                handleClose()
                if (w_dobjective) {
                  localStorage.removeItem('w-dobjective')
                  navigate('/')
                }
              }}
            >
              {t('common.cancel', 'Annuler')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
